import { jsx as t, jsxs as d, Fragment as y } from "react/jsx-runtime";
import n from "dayjs";
import f from "react-calendar";
import { c as x, g as h, p as b, u as j } from "../uk-DtS-21WL.js";
import { Popover as v, PopoverPanel as g } from "@headlessui/react";
import { Buttons as k } from "./Buttons.js";
var m = { exports: {} };
(function(a, s) {
  (function(e, r) {
    a.exports = r();
  })(x, function() {
    return { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(e) {
      var r = ["th", "st", "nd", "rd"], o = e % 100;
      return "[" + e + (r[(o - 20) % 10] || r[o] || r[0]) + "]";
    } };
  });
})(m);
var F = m.exports;
const M = /* @__PURE__ */ h(F);
n.locale(b);
n.locale(j);
n.locale(M);
const C = ({
  format: a,
  locale: s = "pl",
  maxDetail: e = "year",
  value: r,
  onChange: o,
  onLeftArrowClick: p,
  onRightArrowClick: l,
  ...u
}) => /* @__PURE__ */ t(v, { children: ({ close: c }) => /* @__PURE__ */ d(y, { children: [
  /* @__PURE__ */ t(
    k,
    {
      value: r,
      format: a,
      onLeftArrowClick: p,
      onRightArrowClick: l
    }
  ),
  /* @__PURE__ */ t(g, { className: "absolute z-[50] mt-2", children: /* @__PURE__ */ t(
    f,
    {
      className: "jm-date-picker-wrapper",
      value: r,
      locale: s,
      maxDetail: e,
      onChange: (i, _) => {
        o && (o(i, _), c());
      },
      ...u
    }
  ) })
] }) });
export {
  C as MonthPicker
};
//# sourceMappingURL=index.js.map
